import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/v1`,
  withCredentials: true,
});

const QUIET_401 = ["/auth/login", "/auth/me", "/invitations/"];

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err.config?.url || "";
    if (err.response?.status === 401 && !QUIET_401.some((p) => url.includes(p))) {
      window.dispatchEvent(new Event("sist:session-expired"));
    }
    return Promise.reject(err);
  },
);

export function errorMessage(err) {
  if (!err?.response) return "Tidak dapat terhubung ke server. Periksa koneksi Anda.";
  const d = err.response.data?.detail;
  if (typeof d === "string") return d;
  if (d?.message) return d.message;
  return "Terjadi kesalahan. Silakan coba lagi.";
}

export const fetcher = (url) => api.get(url).then((r) => r.data);
